import { createConnectQuery } from '@jotta/grpc-connect-client/createConnectQuery'
import { getCustomerQuery } from '@jotta/grpc-connect-client/customer'
import { getAlbum as getAlbumDescriptor } from '@jotta/grpc-connect-openapi/albumQuery'
import { queryClient } from '@jotta/query'

export const getAlbumQuery = createConnectQuery(getAlbumDescriptor)

function invalidateAlbumMetadataQueryPromises(albumId: string) {
  return [
    getCustomerQuery.invalidate(),
    getAlbumQuery.invalidate({
      albumIdOrShareId: albumId,
    }),
    queryClient.invalidateQueries({
      queryKey: ['album', 'info', { albumId }],
    }),
    queryClient.invalidateQueries({
      queryKey: ['albumList'],
    }),
    queryClient.invalidateQueries({ queryKey: ['publicSharedPhotos'] }),
  ]
}

export async function invalidateAlbumMetadataQueries(albumId: string) {
  await Promise.allSettled(invalidateAlbumMetadataQueryPromises(albumId))
}

export async function invalidateAlbumQueries(albumId: string) {
  await Promise.allSettled([
    ...invalidateAlbumMetadataQueryPromises(albumId),
    queryClient.invalidateQueries({
      queryKey: ['album', 'photos', { albumId }],
    }),
  ])
}

export function useAlbum(albumIdOrShareId: string) {
  return getAlbumQuery({
    variables: {
      albumIdOrShareId,
    },
    enabled: Boolean(albumIdOrShareId),
    select: data => data.album,
  })
}
